<template>
  <div
    :class="['constraint-item',{'deleted':deleted, 'creating':isCreating}] "
    :aria-disabled="deleted"
    :disabled="deleted"
    :expanded="isExpanded"
  >
    <header>
      <div :class="['decorator',{expanded:isExpanded}]">
        <i
          :class="['fas', {'fa-chevron-down':isAllExpandable}, {'fa-chevron-right':!isAllExpandable}]"
          @click="isAllExpandable = !isAllExpandable"
        />
      </div>

      <div v-if="allowDateSelection">
        <span
          :class="['summary',{'active':viewState.showDates}]"
          @click.prevent="activatePanel('showDates', true)"
        >
          <span v-if="!constraint.absoluteFrom && !constraint.absoluteTo">No Date Constraint</span>
          <span v-else>
            <span
              class="selected"
              v-if="constraint.absoluteFrom"
            >From : {{Moment(constraint.absoluteFrom).format("DD/MM/YYYY")}}</span>
            <span>&nbsp;</span>
            <span
              class="selected"
              v-if="constraint.absoluteTo"
            >To : {{Moment(constraint.absoluteTo).format("DD/MM/YYYY")}}</span>
          </span>
          <button>
            <i class="fas fa-cog" />
          </button>
        </span>
      </div>
      <!---->
      <div v-if="allowDayOfWeekSelection">
        <span
          :class="['summary', {'active':viewState.showDayOfWeek}]"
          @click.prevent="activatePanel('showDayOfWeek', true)"
        >
          <span v-for="i in 7" :key="i">
            <span :class="[{'selected':isDayOfWeekBitEnabled(i)}]">{{Moment().day(i).format("dd")}}</span>
            <span v-if="i<7">&nbsp;</span>
          </span>
          <button>
            <i class="fas fa-cog" />
          </button>
        </span>
      </div>
      <!---->
      <div v-if="allowDayOfMonthSelection">
        <span
          :class="['summary', {'active':viewState.showMonths}]"
          @click.prevent="activatePanel('showMonths', true)"
        >
          <span v-if="hasDayOfMonthConstraint" class="selected">Month constraints</span>
          <span v-else>No month constraint</span>

          <button>
            <i class="fas fa-cog" />
          </button>
        </span>
      </div>
      <!---->
      <div v-if="allowPeriodSelection">
        <span
          :class="['summary', {'active':viewState.showPeriods}]"
          @click.prevent="activatePanel('showPeriods', true)"
        >
          <span v-if="hasPeriodConstraint" class="selected">Period constraints</span>
          <span v-else>No Period constraints</span>

          <button>
            <i class="fas fa-cog" />
          </button>
        </span>
      </div>
      <div class="actions">
        <button v-if="updated" @click.prevent="save">
          <i class="fas fa-save" />Save
        </button>
        <button v-if="updated" @click.prevent="reset">
          <i class="fas fa-undo" />Reset
        </button>
        <button @click.prevent="remove" v-if="!isCreating">
          <i class="fas fa-trash" />Delete
        </button>
        <button v-else @click.prevent="cancelConstraint">
          <i class="fa fa-times" />Cancel
        </button>
      </div>
      <!---->
    </header>

    <div class="config" v-show="isAllExpandable">
      <section v-if="allowDateSelection">
        <header>
          <h4>Dates</h4>
          <button @click.prevent="viewState.showDates=false">
            <i class="fa fa-times" />
          </button>
        </header>
        <div class="config-section">
          <label>From :</label>
          <input
            type="date"
            :value="constraint.absoluteFrom ? constraint.absoluteFrom.split('T')[0] : constraint.absoluteFrom"
            @input="(value) => updateDate('absoluteFrom', value)"
            @change="updated=true"
          />
          <label>To :</label>
          <input
            type="date"
            :value="constraint.absoluteTo ? constraint.absoluteTo.split('T')[0] : constraint.absoluteTo"
            @input="(value) => updateDate('absoluteTo', value)"
            @change="updated=true"
          />
        </div>
      </section>
      <section v-if="allowDayOfWeekSelection">
        <header>
          <h4>Week days</h4>
          <button @click.prevent="viewState.showDayOfWeek=false">
            <i class="fa fa-times" />
          </button>
        </header>
        <div class="config-section">
          <a
            :class="['wd',{'selected':isWeekDaysBitsEnabled()}]"
            @click.prevent="toggleWeekDays"
            href="#"
          >
            <i class="fa fa-check" /> Week
          </a>
          <a
            :class="['wd',{'selected':isWeekEndBitsEnabled()}]"
            @click.prevent="toggleWeekEnd"
            href="#"
          >
            <i class="fa fa-check" /> Weekend
          </a>
          <a class="separator">|</a>
          <a
            :class="['wd',{'selected':isDayOfWeekBitEnabled(dayOfWeek)}]"
            href="#"
            v-for="dayOfWeek in 7"
            :key="dayOfWeek"
            @click.prevent="toggleWeekDay(dayOfWeek)"
          >
            <i class="fa fa-check" />
            {{Moment().day(dayOfWeek).format("dddd")}}
          </a>
        </div>
      </section>
      <section v-if="allowDayOfMonthSelection">
        <header>
          <h4>Month Days</h4>
          <button @click.prevent="viewState.showMonths=false">
            <i class="fa fa-times" />
          </button>
        </header>
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th v-for="i in 31" :key="i" class="cell-dom">
                <a href="#" @click.prevent="toggleDayOfMonthBitDays(i)">{{i}}</a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="m in 12" :key="m">
              <th>
                <a
                  href="#"
                  @click.prevent="toggleDayOfMonthBitMonth(m)"
                >{{(Moment([2020, m-1,1])).format("MMM")}}</a>
              </th>
              <td
                class="cell-dom"
                v-for="day in numberOfDaysInMonth(m)"
                :key="day"
                :class="[{selected:isDayOfMonthBitEnabled(m,day)}]"
              >
                <a href="#" @click.prevent="toggleDayOfMonthBit(m,day)">
                  <i class="fa fa-check" />
                </a>
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </section>
      <section v-if="allowPeriodSelection">
        <header>
          <h4>Day Periods</h4>
          <div>
            <button @click.prevent="viewState.showPeriods=false">
              <i class="fa fa-times" />
            </button>
          </div>
        </header>
        <span>
          <div class="periods">
            <div v-for="col in 4" :key="col">
              <!-- <span class="wd">
                <i class="fa fa-check" />
                {{minToMoment((col-1)*6*60).format("HH:mm")}} - {{minToMoment((((col-1)*6)+6)*60).format("HH:mm")}}
              </span>-->
              <div v-for="row in 6" :key="row">
                <span
                  :class="['wd',{ 'selected':isPeriodBitEnabled((((col-1)*6 + row)*2)-1) }]"
                  @click.prevent="togglePeriodBit((((col-1)*6 + row)*2)-1)"
                >
                  <i class="fa fa-check" />
                  {{periods[(((col-1)*6 + row)*2)-1].startTime}} - {{periods[(((col-1)*6 + row)*2)-1].endTime}}
                </span>
                <span
                  :class="['wd',{ 'selected':isPeriodBitEnabled((((col-1)*6 + row)*2)) }]"
                  @click.prevent="togglePeriodBit((((col-1)*6 + row)*2))"
                >
                  <i class="fa fa-check" />
                  {{periods[(((col-1)*6 + row)*2)].startTime}} - {{periods[(((col-1)*6 + row)*2)].endTime}}
                </span>
              </div>
            </div>
          </div>
        </span>
      </section>
    </div>
  </div>
</template>

<script>
import T_CST from "@/apis/_apiTimeConstraints";
import ToggleInput from "@/components/common/ToggleInput";
import Moment from "moment";
import { HTTP } from "@/utils/http";
import Apis from "@/apis/index";
import Regex from "@/apis/regex";

export default {
  components: { ToggleInput },
  computed: {
    Moment: () => Moment,
    T_CST: () => T_CST,
    periods() {
      var $periods = {};
      for (var i = 1, start = 0; i <= 48; i++, start += 30) {
        var $period = {
          id: i,
          start: start,
          end: start + 30,
          startTime: this.minToMoment(start).format("HH:mm"),
          endTime: this.minToMoment(start + 30).format("HH:mm")
        };
        $periods[i] = $period;
      }
      return $periods;
    },
    monthDaysActivated() {
      var enabledDays = {};
      var allActive = true;
      for (var day = 1; day <= 31; day++) {
        var mask = Math.pow(2, day - 1);
        for (var i = 1; i <= 12; i++) {
          enabledDays[i] = enabledDays[i] || { allActives: true };
          var propName = this.getMonthMask(i);
          var domValue = this.constraint[propName];
          var isMonthDayActive = (domValue & mask) > 0;
          enabledDays[i][day] = isMonthDayActive;
          if (!isMonthDayActive) enabledDays[i].allActive = false;
        }
      }
      return enabledDays;
    },
    hasDayOfWeekConstraint() {
      if (this.constraint == null) return false;
      return this.constraint.dayOfWeekMask <= T_CST.ALL_WEEKDAYS_ON;
    },
    hasDayOfMonthConstraint() {
      // Check if any month has a value less than the default value
      if (this.constraint == null) return false;
      var hasConstraint = false;
      for (var month = 1; month <= 12; month++) {
        var propName = this.getMonthMask(month);
        var domValue = this.constraint[propName];
        if (
          (domValue &
            T_CST.DAY_OF_MONTH_MASKS[month]) /* To remove extra bits*/ <
          T_CST.DAY_OF_MONTH_MASKS[month]
        )
          return true;
      }
      return false;
    },
    hasPeriodConstraint() {
      if (this.constraint == null) return false;
      return (
        this.constraint.periodOfDayMask.beforeMidDay < 16777215 ||
        this.constraint.periodOfDayMask.afterMidDay < 16777215
      );
    },
    isExpanded() {
      var state =
        this.viewState.showDates ||
        this.viewState.showDayOfWeek ||
        this.viewState.showMonths ||
        this.viewState.showPeriods;
      return state;
    },
    isCreating() {
      return (
        this.constraint == null ||
        this.constraint.uid == null ||
        !this.constraint.uid.match(Regex.UUID)
      );
    }
  },

  props: {
    parentUid: { required: false },
    typeId: { required: false },
    originalConstraint: { type: Object, required: false },
    allowDateSelection: { type: Boolean, default: true },
    allowDayOfWeekSelection: { type: Boolean, default: true },
    allowDayOfMonthSelection: { type: Boolean, default: true },
    allowPeriodSelection: { type: Boolean, default: true }
  },
  watch: {
    originalConstraint: function(to, from) {
      this.constraint = this.prepareCopy();
      this.updated = false;
    },
    updated: function (val) {
      if (val === true) {
        this.$store.commit('setStatusConstraint', true)
      } else {
        this.$store.commit('setStatusConstraint', false)
      }
    }
  },
  data() {
    //let copy = this.prepareCopy();
    return {
      viewState: {
        showDates: false,
        showDayOfWeek: false,
        showMonths: false,
        showPeriods: false
      },
      updated: false,
      deleted: false,
      constraint: this.prepareCopy(),
      isAllExpandable: false
    };
  },
  methods: {
    cancelConstraint(){
      this.$emit('onCancel');
      this.$store.commit('setStatusConstraint', false)
    },
    numberOfDaysInMonth(month) {
      const is31 = [1, 3, 5, 7, 8, 10, 12];
      const is30 = [4, 6, 9, 11];
      const is29 = [2];

      if (is31.includes(month)) {
        return 31;
      }
      if (is30.includes(month)) {
        return 30;
      }
      if (is29.includes(month)) {
        return 29;
      }
    },
    prepareCopy() {
      var copy = Object.assign(
        {},
        this.originalConstraint || T_CST.DEFAULT_CONSTRAINT
      );
      // Must do next instruction because previous one copy only the reference for periodOfDayMask
      copy.periodOfDayMask = Object.assign({}, copy.periodOfDayMask);
      return copy;
    },
    toggleDates(value) {
      this.viewState.showDates = value;
    },
    toggleDayOfWeek(value) {
      this.viewState.showDayOfWeek = value;
    },
    toggleMonths(value) {
      this.viewState.showMonths = value;
    },
    togglePeriods(value) {
      this.viewState.showPeriods = value;
    },
    resetViewState(currentState) {
      this.viewState = {
        showDates: currentState || false,
        showDayOfWeek: currentState || false,
        showMonths: currentState || false,
        showPeriods: currentState || false
      };
    },
    activatePanel(propName, state) {
      this.resetViewState();
      this.$set(this.viewState, propName, state || false);
    },
    getMonthMask(month) {
      return "dayOfMonthMask" + (month < 10 ? "0" : "") + month;
    },
    toggleWeekDay(wd) {
      this.updated = true;
      var mask = Math.pow(2, wd - 1);
      var isDayActive = (this.constraint.dayOfWeekMask & mask) > 0;
      if (isDayActive) {
        this.constraint.dayOfWeekMask = this.constraint.dayOfWeekMask ^ mask;
      } else {
        this.constraint.dayOfWeekMask = this.constraint.dayOfWeekMask | mask;
      }
    },
    toggleWeekDays() {
      this.updated = true;
      if (this.constraint == null) return;
      var isWeekDaysActive =
        (this.constraint.dayOfWeekMask & T_CST.WEEKDAYS_ON) > 0;
      if (isWeekDaysActive) {
        this.constraint.dayOfWeekMask =
          this.constraint.dayOfWeekMask & T_CST.WEEKEND_ON;
      } else {
        this.constraint.dayOfWeekMask =
          this.constraint.dayOfWeekMask | T_CST.WEEKDAYS_ON;
      }
    },
    toggleWeekEnd() {
      this.updated = true;
      if (this.constraint == null) return;
      var isWeekEndActive =
        (this.constraint.dayOfWeekMask & T_CST.WEEKEND_ON) > 0;
      if (isWeekEndActive) {
        this.constraint.dayOfWeekMask =
          this.constraint.dayOfWeekMask & T_CST.WEEKDAYS_ON;
      } else {
        this.constraint.dayOfWeekMask =
          this.constraint.dayOfWeekMask | T_CST.WEEKEND_ON;
      }
    },
    toggleDayOfMonthBitDays(day) {
      this.updated = true;
      if (this.constraint == null) return;
      var mask = Math.pow(2, day - 1);
      var inverterMask = T_CST.MONTH_31 ^ ~mask;
      var allActive = true;
      for (var i = 1; i <= 12; i++) {
        if (!this.monthDaysActivated[i][day] === true) allActive = false;
      }
      for (var i = 1; i <= 12; i++) {
        var propName = this.getMonthMask(i);
        var domValue = this.constraint[propName];
        if (allActive) {
          this.$set(this.constraint, propName, domValue & ~(~domValue ^ mask));
        } else {
          this.$set(this.constraint, propName, domValue | mask);
        }
      }
    },
    toggleDayOfMonthBitMonth(month) {
      this.updated = true;
      // console.log("Toggle month");
      if (this.constraint == null) return; // Activate by default
      var propName = this.getMonthMask(month);
      var mask = T_CST.DAY_OF_MONTH_MASKS[month] || 0;
      if (this.constraint[propName] == 0 || this.constraint[propName] < mask) {
        // console.log("Activate from default : ", mask);
        this.$set(this.constraint, propName, mask);
      } else {
        // console.log("Activate from default : ", mask);
        this.$set(this.constraint, propName, 0);
      }
    },
    // Toggle a specific month value
    toggleDayOfMonthBit(m, day) {
      this.updated = true;
      if (this.constraint == null) return; // Activate by default
      var propName = this.getMonthMask(m);
      var domValue = this.constraint[propName];
      var mask = Math.pow(2, day - 1);
      var isActive = (domValue & mask) > 0;
      this.$set(
        this.constraint,
        propName,
        isActive ? domValue ^ mask : domValue | mask
      );
    },
    isWeekDaysBitsEnabled() {
      return (
        (this.constraint.dayOfWeekMask & T_CST.WEEKDAYS_ON) ===
        T_CST.WEEKDAYS_ON
      );
    },
    isWeekEndBitsEnabled() {
      return (
        (this.constraint.dayOfWeekMask & T_CST.WEEKEND_ON) === T_CST.WEEKEND_ON
      );
    },
    isDayOfWeekBitEnabled(dof) {
      var mask = Math.pow(2, dof - 1);
      return (this.constraint.dayOfWeekMask & mask) > 0;
    },
    isDayOfMonthBitEnabled(m, day) {
      if (this.constraint == null) return true; // Activate by default
      var propName = this.getMonthMask(m);
      var domValue = this.constraint[propName];
      var mask = Math.pow(2, day - 1);
      //console.log(propName, domValue, Math.pow(2, day - 1), isActive);
      // return is active
      return (domValue & mask) > 0;
    },
    getPeriodBitIndex(periodNumber) {
      return (periodNumber <= 24 ? periodNumber : periodNumber - 24) - 1;
    },
    togglePeriodBit(periodNumber) {
      this.updated = true;
      if (this.constraint == null) return; // Activate by default
      var bitIndex = this.getPeriodBitIndex(periodNumber);
      var domValue =
        periodNumber <= 24
          ? this.constraint.periodOfDayMask.beforeMidDay
          : this.constraint.periodOfDayMask.afterMidDay;
      var mask = Math.pow(2, bitIndex);

      var isActive = (domValue & mask) > 0;

      if (periodNumber <= 24)
        this.constraint.periodOfDayMask.beforeMidDay = isActive
          ? domValue ^ mask
          : domValue | mask;
      else
        this.constraint.periodOfDayMask.afterMidDay = isActive
          ? domValue ^ mask
          : domValue | mask;
    },
    isPeriodBitEnabled(periodNumber) {
      if (this.constraint == null) return true; // Activate by default

      /* BECAUSE MORE THAN 32 BITS BITWISE OPERATION FAIL -> PERIODS SPLITTED IN 2 x 24 */
      var bitIndex = this.getPeriodBitIndex(periodNumber);

      var domValue =
        periodNumber <= 24
          ? this.constraint.periodOfDayMask.beforeMidDay
          : this.constraint.periodOfDayMask.afterMidDay;
      var mask = Math.pow(2, bitIndex);
      // return is active
      return (domValue & mask) > 0;
    },
    async save() {
      try {
        this.viewState.isUpdating = true;
        var response = null;
        if (this.constraint.uid == null) {
          response = await HTTP.put(Apis.timeConstraints.add, {
            stationUid: this.$route.params.stationUid,
            parentUid: this.parentUid,
            typeId: this.typeId,
            constraint: this.constraint
          });
          console.log("Response:", response);
          this.$emit("onCreated", response.data.dataItem);
        } else {
          console.log("Edit");
          response = await HTTP.post(Apis.timeConstraints.edit.default, {
            stationUid: this.$route.params.stationUid,
            constraint: this.constraint
          });
          this.$emit("onUpdated", response.data.dataItem);
        }
        // Set updated to false : because the new state is "not updated" after an update
        this.updated = false;
        // Item should be updated
      } catch (e) {
        alert("An Error Occured");
      } finally {
        this.viewState.isUpdating = false;
      }
    },
    reset() {
      this.constraint = this.prepareCopy();
      this.updated = false;
    },
    async remove() {
      try {
        var response = await HTTP.delete(Apis.timeConstraints.delete, {
          data: {
            stationUid: this.$route.params.stationUid,
            uid: this.constraint.uid
          }
        });
        this.deleted = true;
        this.$emit("onDeleted", this.constraint);
      } catch (e) {
        console.log(e);
        alert("An Error Occured" + JSON.stringify(e));
      }
    },
    updateDate (field, event) {
      this.constraint[field] = event.target.value + 'T00:00:00'
    }
  }
};
</script>
<style scoped lang="scss">
tr th:first-child {
  position: sticky;
  left: 0;
  background: white;
}
tr th:first-child::after {
  content: "";
  background: var(--COLOR_BORDERS);
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
}
.constraint-item {
  &.deleted {
    display: none;
  }
  & > header {
    display: flex;
    //padding: 10px;
    border-top: 1px solid var(--COLOR_BORDERS);
    border-bottom: 1px solid var(--COLOR_BORDERS);
    .actions {
      margin-left: auto;
      border-left: 3px solid #212529;
      padding: 10px;
      background: #fff;
      border-right: 1px solid var(--COLOR_BORDERS);
    }
    button {
      font-size: 11px;
      background: transparent;
      border: none;
      padding: 0;
      margin-left: 10px;
      color: var(--COLOR_TEXT);
      i {
        margin-right: 10px;
      }
      &:hover {
        color: var(--COLOR_BRAND2);
      }
    }
    .decorator {
      margin: 0 15px 0 0;
      background: transparent;
      border: none;
      padding: 0;
      margin-left: 10px;
      color: var(--COLOR_TEXT);

      i.fas.fa-chevron-down {
        color: var(--COLOR_BRAND2);
      }
    }
  }
  // For "creating" state
  &.creating {
    & > header {
      background: var(--COLOR_BRAND2_TRANSPARENT);
      color: white;
    }
    & > header .decorator,
    & span.summary span {
      color: gray;
    }
  }
}

// TODO : Transform to scss
.constraint-item > header .summary {
  cursor: pointer;
  margin-right: 20px;
  position: relative;
}
.constraint-item > header .summary.active {
  background-color: transparent;
  color: var(--COLOR_TEXT);
}
.constraint-item > header .summary.active::after {
  content: "";
  background: var(--COLOR_BRAND2);
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  width: 100%;
  height: 3px;
}
.cell-dom {
  text-align: center;
}
.cell-dom i {
  opacity: 0.75;
  color: var(--COLOR_BORDERS);
  transition: all 0.2s ease-in-out;
}
.cell-dom.selected i {
  color: var(--COLOR_BRAND2);
  opacity: 1;
}
section {
  border: 1px solid var(--COLOR_BORDERS);
  border-top: none;
  overflow: auto;
}
section:last-child {
  margin-bottom: 15px;
}
section .table {
  margin: 0;
  td {
    border-bottom: 1px solid #dee2e6;
  }
}
section header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--COLOR_BORDERS);
  //padding: 15px;
  justify-items: center;
  justify-content: space-between;
}
section header h4 {
  color: var(--COLOR_TEXT);
  font-size: 16px;
  margin: 0;
  font-weight: bolder;
}
section header button {
  background: none;
  border: none;
  color: var(--COLOR_BORDERS);
  font-size: 16px;
  margin: 0;
  font-weight: bolder;
}
section header button:hover {
  color: var(--COLOR_TEXT);
}

section .config-section {
  padding: 15px;
}
section .periods {
  display: flex;
  justify-content: space-between;
}
section .periods > div {
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}
section .periods > div > div {
  flex-grow: 1;
  display: flex;
  justify-content: space-around;
  padding: 5px 5px;
}

section .periods .wd {
  padding: 5px 12px;
  display: inline-block;
  border-radius: 13px;
  text-decoration: none;
  border: 1px solid var(--COLOR_BORDERS);
  color: var(--COLOR_BORDERS);
  margin: 0 10px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}
section .config-section .wd {
  font-size: 14px;
  white-space: nowrap;
  padding: 5px 12px;
  display: inline-block;
  margin-right: 15px;
  border-radius: 13px;
  text-decoration: none;
  border: 1px solid var(--COLOR_BORDERS);
  color: var(--COLOR_BORDERS);
}
section .periods .wd.selected,
section .config-section .wd.selected {
  border: 1px solid var(--COLOR_BRAND2);
  color: var(--COLOR_BRAND2);
}
section .config-section .wd i {
  opacity: 0.75;
  margin-right: 5px;
  color: var(--COLOR_BORDERS);
  transition: all 0.2s ease-in-out;
}
section .periods .wd.selected i,
section .config-section .wd.selected i {
  opacity: 1;
  color: var(--COLOR_BRAND2);
}
section .config-section .separator {
  margin: 0 15px 0 0;
}

span.summary span {
  color: var(--COLOR_BORDERS);
}
span.summary span.selected {
  color: var(--COLOR_TEXT);
}
</style>
